import { z } from 'zod';
import { marketingOptOutSchema } from '../components/MarketingOptOut/validation';

export const newsletterFormSchema = z.object({
  form_type: z.literal('newsletter_form'),
  product: z.union([
    z.literal('blog'),
    z.literal('download_sq_edition'),
    z.literal('sonarcloud'),
    z.literal('sonarlint'),
    z.literal('sonarqube'),
    z.literal('download_sl'),
    z.literal('sqc_oss_version'),
  ]),
  email: z.string().min(1, 'form.Required field').email('form.Invalid email format').max(80),
  ides: z
    .array(
      z
        .object({
          label: z.string(),
          value: z.string(),
        })
        .transform((data) => {
          return data.value;
        })
    )
    .min(1, { message: 'newsletterForm.Please select at least one IDE' })
    .transform((input) => input.join(','))
    .optional(),
  languages: z
    .array(
      z
        .object({
          label: z.string(),
          value: z.string(),
        })
        .transform((data) => {
          return data.value;
        })
    )
    .min(1, { message: 'newsletterForm.Please select at least one language' })
    .transform((input) => input.join(','))
    .optional(),

  campaign_id: z.string().optional(),
  country: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .nullable()
    .transform((data) => data?.value),
  ...marketingOptOutSchema.shape,
});
